import React, { useEffect, useState } from "react";
import AdminSidebar from "../../Components/DashBar";
import MyCalender from "../CheckAvailablity/Availability";
import { useSelector } from 'react-redux';
import { getUserPhone } from '../../redux/loginSlice';
import { getDatabase, ref, onValue } from "firebase/database";
import { useNavigate } from 'react-router-dom';

const DashBoard = () => {
    const navigate = useNavigate();
    const count = useSelector(getUserPhone);
    const db = getDatabase();
    const [isAdmin, setisAdmin] = useState(false);

    useEffect(() => {
        const starCountRef = ref(db, 'Users/' + count + '/data/');
        onValue(starCountRef, (snapshot) => {
            const data1 = snapshot.val();
            if (snapshot.exists()) {
                if (data1.role === "admin" || data1.role === "Manager") {
                    setisAdmin(true);
                } else {
                    setisAdmin(false);
                    navigate('/', { replace: true });
                }
            }
        });
    }, [db, count, navigate]);

    return (
        <AdminSidebar>
            <MyCalender isAdmin={isAdmin} />
        </AdminSidebar>
    );
};

export default DashBoard;